import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { getPlgSDSPSetpointsBtn, getWellConfig } from "../../utils/wellsConfig";
import { ProgressDialog } from "./progressPopup";
import { useState, useEffect } from "react";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

const int16ToUint16 = (n) => {
  return n < 0 ? n + 0x10000 : n;
}

const regListBodyForPCommand = [
  "_41079",
  "_41080",
  "_41081",
  "_41082",
  "_41083",
  "_41084",
  "_41085",
  "_41086",
  "_41087",
  "_41088",
  "_41089",
  "_41090",
  "_41103",
  "_41104",
  "_41105",
  "_41106",
  "_41107",
  "_41108",
  "_41109",
  "_41110",
  "_41111",
  "_41112",
  "_41113",
  "_41114",
  "_41115",
  "_41116",
  "_41117",
  "_41118",
  "_41119",
  "_41120",
  "_41121",
  "_41122",
  "_41123",
  "_41124",
  "_41125",
  "_41126",
  "_41127",
  "_41128",
  "_41129",
  "_41130",
  "_41131",
  "_41132",
  "_41133",
  "_41134",
  "_41135",
  "_41136",
  "_41137",
  "_41138",
];

const SETPOINT_REGISTER_MAP = {
  "Casing Pressure": {
    1: {
      LOLO: 41079,
      LO: 41080,
      HI: 41081,
      HIHI: 41082,
    },
    2: {
      LOLO: 41103,
      LO: 41104,
      HI: 41105,
      HIHI: 41106,
    },
    3: {
      LOLO: 41115,
      LO: 41116,
      HI: 41117,
      HIHI: 41118,
    },
    4: {
      LOLO: 41127,
      LO: 41128,
      HI: 41129,
      HIHI: 41130,
    },
  },
  "Tubing Pressure": {
    1: {
      LOLO: 41083,
      LO: 41084,
      HI: 41085,
      HIHI: 41086,
    },
    2: {
      LOLO: 41107,
      LO: 41108,
      HI: 41109,
      HIHI: 41110,
    },
    3: {
      LOLO: 41119,
      LO: 41120,
      HI: 41121,
      HIHI: 41122,
    },
    4: {
      LOLO: 41131,
      LO: 41132,
      HI: 41133,
      HIHI: 41134,
    },
  },
  "Flow Rate": {
    1: {
      LOLO: 41087,
      LO: 41088,
      HI: 41089,
      HIHI: 41090,
    },
    2: {
      LOLO: 41111,
      LO: 41112,
      HI: 41113,
      HIHI: 41114,
    },
    3: {
      LOLO: 41123,
      LO: 41124,
      HI: 41125,
      HIHI: 41126,
    },
    4: {
      LOLO: 41135,
      LO: 41136,
      HI: 41137,
      HIHI: 41138,
    },
  },
};

export const WellSDSPsTab = ({
  plungerSDSPs,
  setLoading,
  selectedTab,
  selectedDevice,
  refreshData,
}) => {
  const [plungerSPs, setPlungerSPs] = useState(plungerSDSPs);
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");
  const [pinDialogOpen, setPinDialogOpen] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [pendingAction, setPendingAction] = useState(null);

  const handleRegChange = (itemIndex, regKey, newValue) => {
    setPlungerSPs((prev) =>
      prev.map((item, idx) =>
        idx !== itemIndex
          ? item
          : {
              ...item,
              regs: {
                ...item.regs,
                [regKey]: newValue,
              },
            },
      ),
    );
  };

  const handleConfirmPassword = () => {
    const correctPwd = "PRC2103";

    if (passwordInput !== correctPwd) {
      toast.error("Incorrect password");
      return;
    }

    // Success: Close dialog and reset
    setPinDialogOpen(false);
    setPasswordInput("");

    // Execute the saved action
    if (pendingAction) {
      pendingAction();
    }

    setPendingAction(null);
  };

  useEffect(() => {
    setPlungerSPs(plungerSDSPs);
  }, [plungerSDSPs]);

  const handleSubmit = async (index) => {
    // 1. Get ONLY the specific row data using the index
  const itemToUpdate = plungerSPs[index];
    // 2. Check if any fields in THIS specific row are empty
  const isAnyFieldEmpty = Object.values(itemToUpdate.regs).some(
    (val) => val === "" || val === null || val === undefined
  );

    if (isAnyFieldEmpty) {
    toast.error(`❌ Please fill all fields for ${itemToUpdate.label} before submitting.`);
    return;
  }
    // 3. Ensure a device is selected
  if (!selectedDevice?.id) {
    toast.error("No device selected.");
    return;
  }

    const action = () => {
      setProgressOpen(true);
      setProgressSuccess(false);

      // Simulate/Run your update function
      setTimeout(() => {
        // Pass the specific index or data to your update function here
        runDeviceUpdate(index);
      }, 100);
    };
    // 3. Save action and open PIN dialog
    setPendingAction(() => action);
    setPinDialogOpen(true);
  };

  const runDeviceUpdate = async (index) => {
    let pollInterval = null;
    const stopPolling = () => {
      if (pollInterval) {
        clearInterval(pollInterval);
        pollInterval = null;
      }
    };

    const pollForChange = async ({
      unitId,
      registerList,
      lastTime,
      lastResponse,
      durationMs,
      intervalMs,
      onSuccess,
      onTimeout,
    }) => {
      const start = Date.now();

      pollInterval = setInterval(async () => {
        try {
          const resp = await axios.post(
            `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
            registerList,
          );

          const { time: currentTime, response: currentResponse } =
            resp.data.data || {};

          const timeChanged =
            currentTime && Number(currentTime) !== Number(lastTime);

          let valueChanged = false;
          for (const key in currentResponse) {
            if (currentResponse[key] !== lastResponse[key]) {
              valueChanged = true;
              break;
            }
          }

          console.log("⏳ Polling...", {
            currentTime,
            timeChanged,
            valueChanged,
          });

          if (timeChanged && valueChanged) {
            stopPolling();
            onSuccess({
              currentTime,
              currentResponse,
            });
            console.log("🔄 Device time changed:", lastTime, "->", currentTime);
          }

          if (Date.now() - start >= durationMs) {
            stopPolling();
            onTimeout();
          }
        } catch (err) {
          console.warn("Polling error:", err.message);
        }
      }, intervalMs);
    };
    try {
      let cmd = "A";
      const unitId = selectedDevice?.id;
      const wellConfig = await getWellConfig(selectedTab);
      // 1. Get the specific row data using the index
      const selectedRow = plungerSPs[index]; 
      const label = selectedRow.label; // e.g., "Casing Pressure"
      const regs = selectedRow.regs;   // { LOLO, LO, HI, HIHI }
      // 2. Determine which registers to poll/update based on the label
      let targetRegisterIds = [];
      if (label === "Casing Pressure") targetRegisterIds = wellConfig.PLG_SD_SP_CASING_PRESURE;
      if (label === "Tubing Pressure") targetRegisterIds = wellConfig.PLG_SD_SP_TUBING_PRESURE;
      if (label === "Flow Rate") targetRegisterIds = wellConfig.PLG_SD_SP_FLOWRATE_PRESURE;
      // We only poll the 4 registers belonging to this row
      const registerList = targetRegisterIds;
      console.log("register list in body", registerList);
      // Step 1: get initial time
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        registerList,
      );
      let lastTime = Number(initialResp.data.data?.time || 0);
      let lastResponse = initialResp.data.data?.response || {};
      console.log("Initial time:", lastTime);
      console.log("regList:", lastResponse);
      const regKeys = ["LOLO", "LO", "HI", "HIHI"];
      regKeys.forEach((key, i) => {
        const regAddr = SETPOINT_REGISTER_MAP[label][selectedTab][key] - 40001;
        let val = regs[key] * 10;
        val = int16ToUint16(val)
        cmd += `,${regAddr},${val}`;
      });

      // Step 2: Send A command
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
        {
          unitId,
          cmd,
          UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,
        },
        {
          headers: {
            id: "anything",
            "Content-Type": "application/json",
          },
        },
      );
      console.log("Sending command:", cmd);
      console.log("🟡 Polling for 30s...");
      // STEP 3: poll for 30s BEFORE sending P
      pollForChange({
        unitId,
        registerList,
        lastTime,
        lastResponse,
        durationMs: 30000,
        intervalMs: 4000,

        onSuccess: () => {
          console.log("✅ Update done after A command");
          setProgressSuccess(true);
        },

        onTimeout: async () => {
          console.log("⏰ No change after A, sending P command...");

          // === STEP 4: build & send P ===
          let pCmd = cmd.replace("A", "P");
          pCmd = pCmd.replace(/(-?\d+),\s*(?:-?\d+(?:\.\d+)?|NaN)/gi, "$1,1");
          pCmd += `,${wellConfig.STATE - 40001},1`;

          await axios.post(
            `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
            {
              unitId,
              cmd: pCmd,
              UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${pCmd}`,
            },
            { headers: { id: "anything", "Content-Type": "application/json" } },
          );

          console.log("🟢 P command sent, polling again...");

          // === STEP 5: poll AFTER P ===
          pollForChange({
            unitId,
            registerList,
            lastTime,
            lastResponse,
            durationMs: 170000,
            intervalMs: 4000,

            onSuccess: () => {
              console.log("✅ Update done after P command");
              setProgressSuccess(true);
            },

            onTimeout: () => {
              console.warn("❌ Timeout after P command");
              setProgressError(
                "⏰ Timeout waiting for device response. Please try again.",
              );
            },
          });
        },
      });
    } catch (err) {
      console.error("plgSendCommand failed:", err);
      setProgressOpen(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#374151",
        color: "#fff",
        py: 3,
        px: 1,
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <Button
          variant="contained"
          color="primary"
          sx={{ fontSize: 12 }}
          onClick={() =>
            getPlgSDSPSetpointsBtn(
              selectedDevice?.id,
              regListBodyForPCommand,
              "P,1078,12,1102,36",
              setProgressSuccess,
              setProgressError,
              setProgressOpen,
            )
          }
        >
          Get Setpoints
        </Button>
      </Box>

      {plungerSPs.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 3fr auto",
            gap: 2,
            borderBottom: "1px solid #a0a0a0ff",
            py: 1.5,
            alignItems: "center",
          }}
        >
          {/* LABELS & VALUES BLOCK */}
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "column",
                lg: "row",
              },
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {/* LABEL */}
            <Typography
              sx={{
                color: "#ffffffff",
                fontWeight: 600,
                fontSize: 13,
              }}
            >
              {item.label}
            </Typography>
            {/* VALUES */}
            <Typography
              sx={{
                color: "#ffffffff",
                fontWeight: 600,
                fontSize: 13,
                textAlign: "center",
              }}
            >
              {item.value ? item.value : "0"}
            </Typography>
          </Box>

          {/* REGISTERS BLOCK */}
          <Grid container spacing={1} sx={{ width: "100%" }}>
            {Object.entries(item.regs).map(([key, reg]) => (
              <Grid item size={{ xs: 6, md: 6, lg: 3 }} key={key}>
                <TextField
                  label={key.toUpperCase()}
                  value={reg}
                  onChange={(e) => handleRegChange(index, key, e.target.value)}
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    style: { color: "#fff", fontSize: 14 },
                  }}
                  InputProps={{
                    sx: {
                      color: "#fff",
                      backgroundColor: "#1f2937",
                      padding: 0.2,
                      fontSize: 12,
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>

          <Button
            variant="contained"
            size="small"
            sx={{ fontSize: 12, height: 36 }}
            onClick={() => handleSubmit(index)}
          >
            Update
          </Button>
        </Box>
      ))}

      {/* Single ProgressDialog for all updates */}
      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await refreshData();
        }}
        loadingMessage={`Check Device Response. Operation in-progress for well ${selectedTab} ...`}
        successMessage="Successfully updated!"
      />

      {/* Password Dialog */}
      <Dialog open={pinDialogOpen} onClose={() => setPinDialogOpen(false)}>
        <DialogTitle>Update Setpoints</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter password to apply setpoint changes.
          </DialogContentText>

          <TextField
            autoFocus
            margin="dense"
            label="Password"
            type="password"
            fullWidth
            variant="outlined"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleConfirmPassword();
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setPinDialogOpen(false);
              setPasswordInput("");
              setPendingAction(null);
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleConfirmPassword}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
